import { differenceInDays } from 'date-fns';

import type { TrialDetailsQuery as TrialDetailsQueryType } from './__types__/TrialDetailsQuery.ts';

/**
 * @deprecated to be removed, new implementations should use @atlassian/upgrades-and-purchases
 */
export const getTrialDaysLeftFromQuery = (queryData: TrialDetailsQueryType | undefined) => {
	const trialEndDate = queryData?.license?.trialEndDate;
	return getTrialDaysLeft(trialEndDate);
};

/**
 * @deprecated to be removed, new implementations should use @atlassian/upgrades-and-purchases
 */
export const getTrialDaysLeft = (trialEndDate: string | null | undefined) => {
	if (!trialEndDate) {
		return null;
	}

	const difference = differenceInDays(new Date(trialEndDate), new Date());

	// rounding down if in grace period to ensure that the last trial flag at -14 days left is shown when there is less than 1 day left in grace period
	if (difference < 0) {
		return Math.floor(difference);
	}

	// +1 day to round up for fractional days
	return difference + 1;
};
